<template>
  <div class="payments__wrapper">
    <p class="purchase__payment-title">Select payment method</p>
    <div class="purchase__payment__wrapper">
      <button
        class="purchase__payment__btn"
        :class="{ active: isPaypal }"
        @click="onSwitchPaypal"
      >
        <svg
          width="97"
          height="24"
          viewBox="0 0 97 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.8"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.45708 5.65019H15.0801C18.6361 5.65019 19.9747 7.49016 19.7679 10.1968C19.4277 14.6596 16.7863 17.1286 13.285 17.1286H11.5173C11.0369 17.1286 10.7138 17.4536 10.5838 18.3343L9.82477 23.4505C9.77519 23.7825 9.60423 23.9783 9.34778 24.001H5.19513C4.80363 24.001 4.66515 23.6952 4.76773 23.0329L7.3048 6.61997C7.40566 5.96296 7.75784 5.64844 8.45878 5.64844L8.45708 5.65019Z"
            fill="#B3C6CB"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M37.2111 5.34529C39.4455 5.34529 41.5073 6.58417 41.2252 9.67176C40.8901 13.3325 38.96 15.3716 35.9237 15.3804H33.2755C32.8943 15.3804 32.7096 15.6984 32.6105 16.3502L32.0993 19.6824C32.0224 20.1856 31.7694 20.4338 31.3967 20.4338H28.9297C28.5365 20.4338 28.3997 20.1769 28.4869 19.602L30.5265 6.24344C30.6273 5.58643 30.8718 5.3418 31.3078 5.3418H37.2128L37.2111 5.34529ZM33.1935 12.4955H35.2023C36.4588 12.4466 37.2931 11.5589 37.3769 9.95308C37.4282 8.96233 36.7734 8.2529 35.7322 8.25814L33.8414 8.26688L33.1935 12.4955ZM47.932 19.4115C48.1577 19.2019 48.3868 19.0935 48.3543 19.3521L48.274 19.9707C48.2329 20.294 48.3577 20.4652 48.6518 20.4652H50.8435C51.2128 20.4652 51.3923 20.3132 51.4829 19.7296L52.8335 11.0662C52.9019 10.6311 52.7976 10.4179 52.4745 10.4179H50.0656C49.8485 10.4179 49.7425 10.5419 49.6861 10.8809L49.5972 11.4139C49.551 11.6917 49.4262 11.7406 49.31 11.4611C48.9014 10.472 47.8585 10.0282 46.3951 10.0579C43.0152 10.1296 40.7363 12.7524 40.4918 16.1143C40.3037 18.7144 42.1262 20.757 44.5299 20.757C46.2737 20.757 47.0533 20.2258 47.932 19.4115ZM46.0976 18.0801C44.6427 18.0801 43.6289 16.8936 43.8392 15.4398C44.0512 13.986 45.4104 12.7995 46.8652 12.7995C48.3201 12.7995 49.3339 13.986 49.1236 15.4398C48.9116 16.8936 47.5525 18.0801 46.0976 18.0801ZM57.1246 10.3882H54.9107C54.4525 10.3882 54.2662 10.7307 54.4115 11.1675L57.1708 19.4255L54.4525 23.3536C54.2251 23.6821 54.4012 23.9809 54.7209 23.9809H57.2187C57.5914 23.9809 57.7726 23.883 57.9606 23.6087L66.4472 11.1675C66.7087 10.7848 66.5856 10.3829 66.1565 10.3829H63.7955C63.3904 10.3794 63.228 10.5437 62.9954 10.8897L59.4565 16.1387L57.882 10.8809C57.7845 10.5577 57.5537 10.3899 57.1281 10.3899L57.1246 10.3882Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M75.2772 5.34529C77.5117 5.34529 79.5735 6.58417 79.2914 9.67176C78.9563 13.3325 77.0261 15.3716 73.9899 15.3804H71.3417C70.9604 15.3804 70.7758 15.6984 70.6766 16.3502L70.1655 19.6824C70.0885 20.1856 69.8355 20.4338 69.4628 20.4338H66.9958C66.6026 20.4338 66.4659 20.1769 66.5531 19.602L68.5926 6.24343C68.6935 5.58643 68.938 5.3418 69.3739 5.3418H75.2789L75.2772 5.34529ZM71.2596 12.4955H73.2684C74.525 12.4466 75.3593 11.5589 75.443 9.95308C75.4943 8.96233 74.8395 8.2529 73.7984 8.25814L71.9076 8.26688L71.2596 12.4955ZM85.9982 19.4115C86.2239 19.2019 86.4529 19.0935 86.4205 19.3521L86.3401 19.9707C86.2991 20.294 86.4239 20.4652 86.7179 20.4652H88.9097C89.2789 20.4652 89.4584 20.3132 89.5491 19.7296L90.8996 11.0662C90.968 10.6311 90.8637 10.4179 90.5406 10.4179H88.1318C87.9147 10.4179 87.8087 10.5419 87.7522 10.8809L87.6634 11.4139C87.6172 11.6917 87.4924 11.7406 87.3761 11.4611C86.9675 10.472 85.9247 10.0282 84.4612 10.0579C81.0813 10.1296 78.8024 12.7524 78.558 16.1143C78.3699 18.7143 80.1923 20.757 82.5961 20.757C84.3399 20.757 85.1194 20.2258 85.9982 19.4115ZM84.1638 18.0801C82.7089 18.0801 81.6951 16.8936 81.9054 15.4398C82.1174 13.986 83.4765 12.7995 84.9314 12.7995C86.3863 12.7995 87.4001 13.986 87.1898 15.4398C86.9778 16.8936 85.6187 18.0801 84.1638 18.0801ZM94.2727 20.4809H91.7425C91.5408 20.4809 91.4023 20.3202 91.433 20.1227L93.6573 5.73146C93.688 5.53401 93.8778 5.37325 94.0778 5.37325H96.608C96.8098 5.37325 96.9483 5.53401 96.9175 5.73146L94.6933 20.1227C94.6625 20.3202 94.4744 20.4809 94.2727 20.4809Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.31477 0H10.9447C12.8116 0 15.0272 0.0611576 16.5077 1.39789C17.4976 2.29079 18.0173 3.7114 17.8977 5.23684C17.4908 10.4108 14.463 13.3097 10.401 13.3097H7.13051C6.57317 13.3097 6.20561 13.6871 6.04832 14.7075L5.13539 20.6398C5.07555 21.0243 4.91314 21.2514 4.61567 21.2794H0.533111C0.0800632 21.2794 -0.0806404 20.9247 0.0373229 20.1576L2.97786 1.1253C3.09582 0.361704 3.50442 0 4.31477 0Z"
            fill="white"
          />
          <path
            opacity="0.1"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.14551 14.1109L7.30292 6.61997C7.40378 5.96296 7.75596 5.64844 8.45691 5.64844H15.0799C16.1758 5.64844 17.0631 5.82317 17.7572 6.14644C17.0922 10.7525 14.1773 13.3106 10.3614 13.3106H7.09092C6.6601 13.3106 6.33869 13.536 6.14551 14.1109Z"
            fill="#134E5E"
          />
        </svg>
      </button>
      <button
        @click="isPaypal = false"
        class="purchase__payment__btn"
        :class="{ active: !isPaypal }"
      >
        <span>
          <span class="purchase__payment__btn-title">Credit card</span>
          <svg width="103" height="19" viewBox="0 0 103 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M100 1H81a2 2 0 00-2 2v13a2 2 0 002 2h19a2 2 0 002-2V3a2 2 0 00-2-2z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M84.05 7.5h-1.3l-1.72 4h1.2l.33-1h1.69l.32 1h1.2l-1.72-4zM82.83 10l.58-1.42.57 1.42h-1.15zM91 7.5h-1.24l-1.2 1.46-1.2-1.46h-.86v4h1V9.24l1 1.26h.09l.91-1.26v2.26H91v-4zM94.5 7.5H92v4h3v-1h-2V10h1.5V9H93v-.5h1.5v-1zM99.75 7.5h-1.47c-.289.353-.556.724-.8 1.11l-.82-1.11h-1.5l1.58 1.92-1.66 2.08h1.49c.41-.5.48-.58.91-1.16.21.28.76.93 1 1.16h1.51l-1.72-2.08 1.52-1.92h-.04z" fill="#fff"/><path d="M22 1H3a2 2 0 00-2 2v13a2 2 0 002 2h19a2 2 0 002-2V3a2 2 0 00-2-2z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.45 7.5h1.28l.41 4h.69L9.8 7.39M11.61 7.469l-.81 4.06M15.33 7.419s-1.38-.36-1.85.42c-.47.78.27 1.28.75 1.58.48.3 1 .75.88 1.28s-.73 1.32-2.3.77M16.5 11.53l1.94-4.05.73.02.33 3.97M17.09 10.328h2.33M61 1H42a2 2 0 00-2 2v13a2 2 0 002 2h19a2 2 0 002-2V3a2 2 0 00-2-2z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M46.5 6.5h-1v1h1v-1zM50.5 6.5h-1v1h1v-1zM50.5 8.5h-1v1h1v-1zM50.5 10.5h-1v1h1v-1zM50.5 12.5h-1v1h1v-1zM46.5 8.5h-1v1h1v-1zM46.5 10.5h-1v1h1v-1zM46.5 12.5h-1v1h1v-1zM48.5 7.5h-1v1h1v-1zM48.5 5.5h-1v1h1v-1zM48.5 9.5h-1v1h1v-1zM52.5 9.5h-1v1h1v-1zM48.5 11.5h-1v1h1v-1zM48.5 13.5h-1v1h1v-1zM44.5 9.5h-1v1h1v-1z" fill="#fff"/><path d="M53 10a5 5 0 11-10 0 5 5 0 0110 0v0z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M53 10a5 5 0 11-10 0 5 5 0 0110 0v0z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M51.75 13.28a5 5 0 100-6.56" stroke="#fff" stroke-linejoin="round"/><path d="M46.5 14h-1v.3c.316.186.651.337 1 .45V14zM50.5 14h-1v.75a4.996 4.996 0 001-.45V14zM52.5 11.5h-1v1h.8c.07-.12.14-.24.2-.36v-.64zM52.3 7.5h-.8v1h1v-.64c-.06-.12-.13-.24-.2-.36zM44.5 11.5h-1v.64c.06.12.13.24.2.36h.8v-1zM44.5 7.5h-.8c-.07.12-.14.24-.2.36v.64h1v-1z" fill="#fff"/></svg>
        </span>
      </button>
    </div>
    <div class="lifetime" v-if="isLifetime && !isPaypal">
      <button
        @click="onSendStripe"
        class="unlock-subscribe__try__btn purchase__btn"
      >
        Try Mental Future Now with Stripe
      </button>
    </div>
    <a-spin
      v-show="!isPaypal && !isLifetime"
      :spinning="isCardLoading || isLoading"
    >
      <div class="purchase__card p-card">
        <div class="purchase__card-head">
          <svg width="103" height="19" viewBox="0 0 103 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M100 1H81a2 2 0 00-2 2v13a2 2 0 002 2h19a2 2 0 002-2V3a2 2 0 00-2-2z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M84.05 7.5h-1.3l-1.72 4h1.2l.33-1h1.69l.32 1h1.2l-1.72-4zM82.83 10l.58-1.42.57 1.42h-1.15zM91 7.5h-1.24l-1.2 1.46-1.2-1.46h-.86v4h1V9.24l1 1.26h.09l.91-1.26v2.26H91v-4zM94.5 7.5H92v4h3v-1h-2V10h1.5V9H93v-.5h1.5v-1zM99.75 7.5h-1.47c-.289.353-.556.724-.8 1.11l-.82-1.11h-1.5l1.58 1.92-1.66 2.08h1.49c.41-.5.48-.58.91-1.16.21.28.76.93 1 1.16h1.51l-1.72-2.08 1.52-1.92h-.04z" fill="#fff"/><path d="M22 1H3a2 2 0 00-2 2v13a2 2 0 002 2h19a2 2 0 002-2V3a2 2 0 00-2-2z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.45 7.5h1.28l.41 4h.69L9.8 7.39M11.61 7.469l-.81 4.06M15.33 7.419s-1.38-.36-1.85.42c-.47.78.27 1.28.75 1.58.48.3 1 .75.88 1.28s-.73 1.32-2.3.77M16.5 11.53l1.94-4.05.73.02.33 3.97M17.09 10.328h2.33M61 1H42a2 2 0 00-2 2v13a2 2 0 002 2h19a2 2 0 002-2V3a2 2 0 00-2-2z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M46.5 6.5h-1v1h1v-1zM50.5 6.5h-1v1h1v-1zM50.5 8.5h-1v1h1v-1zM50.5 10.5h-1v1h1v-1zM50.5 12.5h-1v1h1v-1zM46.5 8.5h-1v1h1v-1zM46.5 10.5h-1v1h1v-1zM46.5 12.5h-1v1h1v-1zM48.5 7.5h-1v1h1v-1zM48.5 5.5h-1v1h1v-1zM48.5 9.5h-1v1h1v-1zM52.5 9.5h-1v1h1v-1zM48.5 11.5h-1v1h1v-1zM48.5 13.5h-1v1h1v-1zM44.5 9.5h-1v1h1v-1z" fill="#fff"/><path d="M53 10a5 5 0 11-10 0 5 5 0 0110 0v0z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M53 10a5 5 0 11-10 0 5 5 0 0110 0v0z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M51.75 13.28a5 5 0 100-6.56" stroke="#fff" stroke-linejoin="round"/><path d="M46.5 14h-1v.3c.316.186.651.337 1 .45V14zM50.5 14h-1v.75a4.996 4.996 0 001-.45V14zM52.5 11.5h-1v1h.8c.07-.12.14-.24.2-.36v-.64zM52.3 7.5h-.8v1h1v-.64c-.06-.12-.13-.24-.2-.36zM44.5 11.5h-1v.64c.06.12.13.24.2.36h.8v-1zM44.5 7.5h-.8c-.07.12-.14.24-.2.36v.64h1v-1z" fill="#fff"/></svg>
          <svg width="64" height="20" viewBox="0 0 64 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18.7 8h.58V5.19h2.14c.13 0 .3-.01.48-.04 1.08-.16 1.73-1.05 1.73-2.15 0-1.11-.65-1.99-1.73-2.16-.18-.03-.34-.04-.48-.04H18.7V8zm.58-3.37V1.36h2.13c.11 0 .28.01.44.04.78.16 1.17.86 1.17 1.6 0 .74-.39 1.43-1.17 1.59-.16.03-.33.04-.44.04h-2.13zm6.258-1.65c-.14.11-.27.27-.38.46V2.6h-.53V8h.58V5.32c0-.65.04-1.42.6-1.89.41-.36.92-.38 1.35-.29V2.6c-.47-.14-1.19-.02-1.62.38zm4.679 5.17c1.6 0 2.52-1.15 2.52-2.86 0-1.67-.9-2.84-2.52-2.84-1.57 0-2.51 1.14-2.51 2.84 0 1.68.91 2.86 2.51 2.86zm0-.56c-1.25 0-1.89-.91-1.89-2.3 0-1.34.6-2.28 1.89-2.28 1.27 0 1.9.9 1.9 2.28 0 1.36-.62 2.3-1.9 2.3zm4.81-4.47h1.68V2.6h-1.68V1.1h-.58v1.5h-1.21v.52h1.21v3.01c0 .5-.01.86.16 1.23.34.7 1.23.83 2.1.64v-.52c-.81.13-1.33.07-1.57-.4-.13-.24-.11-.51-.11-.97V3.12zm2.85 2.34h4.36c.03-1.89-.89-3.01-2.47-3.01-1.55 0-2.51 1.09-2.51 2.86 0 1.74.98 2.84 2.53 2.84 1.05 0 1.9-.53 2.34-1.46l-.52-.23c-.37.73-1.01 1.13-1.84 1.13-1.16 0-1.84-.78-1.89-2.13zm1.9-2.46c1.1 0 1.73.68 1.85 1.94h-3.74c.11-1.24.77-1.94 1.89-1.94zm5.781 5.15c1.02 0 1.79-.48 2.21-1.4l-.57-.2c-.3.68-.88 1.04-1.64 1.04-1.25 0-1.88-.91-1.89-2.29.01-1.35.61-2.29 1.89-2.29.75 0 1.38.39 1.65 1.06l.56-.2c-.31-.88-1.17-1.42-2.21-1.42-1.61 0-2.48 1.13-2.51 2.85.03 1.68.88 2.85 2.51 2.85zm4.44-5.03h1.68V2.6h-1.68V1.1h-.58v1.5h-1.21v.52h1.21v3.01c0 .5-.01.86.16 1.23.34.7 1.23.83 2.1.64v-.52c-.81.13-1.33.07-1.57-.4-.13-.24-.11-.51-.11-.97V3.12zm2.85 2.34h4.36c.03-1.89-.89-3.01-2.47-3.01-1.55 0-2.51 1.09-2.51 2.86 0 1.74.98 2.84 2.53 2.84 1.05 0 1.9-.53 2.34-1.46l-.52-.23c-.37.73-1.01 1.13-1.84 1.13-1.16 0-1.84-.78-1.89-2.13zm1.9-2.46c1.1 0 1.73.68 1.85 1.94h-3.74c.11-1.24.77-1.94 1.89-1.94zM62.18.8v2.61c-.39-.6-1.01-.96-1.84-.96-1.47 0-2.32 1.24-2.32 2.84 0 1.62.85 2.86 2.37 2.86.84 0 1.47-.41 1.85-1.07V8h.52V.8h-.58zm-1.75 6.8c-1.19 0-1.79-1-1.79-2.31 0-1.3.57-2.29 1.8-2.29 1.19 0 1.8.95 1.8 2.29 0 1.32-.6 2.31-1.81 2.31zM21.12 11.45c-.88 0-1.52.4-1.9 1.06v-.91h-.52v7.8h.58v-3.23c.38.6.99.98 1.79.98 1.52 0 2.37-1.24 2.37-2.86 0-1.6-.85-2.84-2.32-2.84zm-.09 5.15c-1.21 0-1.81-.99-1.81-2.31 0-1.34.61-2.29 1.8-2.29 1.23 0 1.81.99 1.81 2.29 0 1.31-.61 2.31-1.8 2.31zm7.55-4.05c-.26-.69-.96-1.1-1.96-1.1-1.16 0-1.93.54-2.17 1.53l.59.16c.21-.77.74-1.13 1.57-1.13 1.13 0 1.54.53 1.55 1.63-.63.08-1.7.19-2.5.36-.78.19-1.42.64-1.42 1.56 0 .85.62 1.59 1.86 1.59.94 0 1.7-.39 2.11-1.1V17h.52v-3.37c0-.38-.04-.78-.15-1.08zm-.48 2.48c-.15.96-.87 1.59-1.97 1.59-.97 0-1.3-.56-1.3-1.06 0-.66.55-.94 1.03-1.07.66-.17 1.63-.26 2.29-.33 0 .24 0 .59-.05.87zm5.285-3.43l-1.7 4.63-1.86-4.63h-.62l2.2 5.4-.89 2.4h.6l2.87-7.8h-.6zm6.736-.15c-.72 0-1.32.35-1.63.93-.29-.62-.88-.93-1.57-.93-.64 0-1.18.27-1.51.72v-.57h-.52V17h.58v-3.54c0-.9.53-1.49 1.33-1.49.78 0 1.32.56 1.32 1.46l-.01 3.57h.57v-3.54c0-1.1.72-1.49 1.34-1.49.74 0 1.3.53 1.3 1.4V17h.57l.01-3.72c0-1.13-.72-1.83-1.78-1.83zm3.381 3.01h4.36c.03-1.89-.89-3.01-2.47-3.01-1.55 0-2.51 1.09-2.51 2.86 0 1.74.98 2.84 2.53 2.84 1.05 0 1.9-.53 2.34-1.46l-.52-.23c-.37.73-1.01 1.13-1.84 1.13-1.16 0-1.84-.78-1.89-2.13zm1.9-2.46c1.1 0 1.73.68 1.85 1.94h-3.74c.11-1.24.77-1.94 1.89-1.94zm5.785-.53c-.77 0-1.43.3-1.83.94v-.81h-.53V17h.58v-2.92c0-1.19.53-2.05 1.71-2.05 1.12 0 1.67.8 1.67 2.16V17h.58v-2.96c0-1.4-.69-2.57-2.18-2.57zm4.67.65h1.68v-.52h-1.68v-1.5h-.58v1.5h-1.21v.52h1.21v3.01c0 .5-.01.86.16 1.23.34.7 1.23.83 2.1.64v-.52c-.81.13-1.33.07-1.57-.4-.13-.24-.11-.51-.11-.97v-2.99z" fill="#fff"/><path d="M10.8 8.082H4.5v4.958h6.3V8.082zM7.65 11.624v-1.417" stroke="#fff" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.55 8.083v-.708c0-.564.222-1.104.616-1.503A2.088 2.088 0 017.65 5.25c.557 0 1.09.224 1.485.622.394.399.615.94.615 1.503v.708" stroke="#fff" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 9.854a.356.356 0 01-.102.25.348.348 0 01-.495 0 .356.356 0 01.248-.604c.093 0 .182.037.247.104a.356.356 0 01.103.25z" stroke="#fff" stroke-width=".8" stroke-linejoin="round"/><path d="M1 1h13.3v5.15a12.7 12.7 0 01-1.791 6.508 12.501 12.501 0 01-4.859 4.634 12.501 12.501 0 01-4.859-4.634A12.7 12.7 0 011 6.15V1zM1 3.125h13.3" stroke="#fff" stroke-width=".8" stroke-linejoin="round"/></svg>
        </div>
        <div id="purchase-number" class="purchase__card-number"></div>
        <div class="purchase__card-detail">
          <div id="purchase-card-expiry" />
          <div id="purchase-card-cvc" />
        </div>
        <!-- <p class="purchase__card-info">
          7 days trial then $59.99 for first year (only $4.99/mo)
        </p> -->
        <button
          :disabled="isLoading"
          @click="onConfirm"
          class="unlock-subscribe__try__btn purchase__btn"
        >
          Try Mental Future Now
        </button>
      </div>
    </a-spin>
    <div v-if="isPaypal" class="purchase__payment__paypal">
      <a-spin :spinning="isPaypalLoading">
        <button @click="onClickPaypal" class="purchase__payment__paypal--btn">
          <svg
            width="61"
            height="16"
            viewBox="0 0 61 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.75655 0.00299997C9.73746 0.00299997 11.5653 1.06647 11.3152 3.71688C11.0182 6.85928 9.30703 8.60973 6.61529 8.61723H4.2676C3.92962 8.61723 3.76593 8.89022 3.67803 9.4497L3.22486 12.3101C3.15665 12.7421 2.93234 12.9551 2.60194 12.9551H0.414905C0.0663137 12.9551 -0.054935 12.7346 0.0223614 12.2411L1.83049 0.773976C1.91991 0.209993 2.13665 0 2.52313 0H7.75807L7.75655 0.00299997ZM4.19485 6.14081H5.9757C7.08968 6.09881 7.8293 5.33683 7.90357 3.95838C7.94903 3.1079 7.36855 2.49892 6.44554 2.50342L4.76927 2.51092L4.19485 6.14081ZM17.261 12.0776C17.461 11.8976 17.6641 11.8046 17.6353 12.0266L17.5641 12.5576C17.5277 12.8351 17.6384 12.9821 17.8991 12.9821H19.8421C20.1694 12.9821 20.3286 12.8516 20.4089 12.3506L21.6063 4.91385C21.6669 4.54036 21.5744 4.35736 21.288 4.35736H19.1525C18.96 4.35736 18.866 4.46386 18.816 4.75485L18.7372 5.21234C18.6963 5.45083 18.5856 5.49283 18.4826 5.25283C18.1203 4.40386 17.1958 4.02287 15.8984 4.04837C12.9021 4.10987 10.8818 6.3613 10.665 9.24721C10.4983 11.4791 12.1139 13.2326 14.2449 13.2326C15.7908 13.2326 16.482 12.7766 17.261 12.0776ZM15.6347 10.9347C14.3449 10.9347 13.4462 9.91619 13.6326 8.66823C13.8205 7.42027 15.0254 6.4018 16.3152 6.4018C17.605 6.4018 18.5038 7.42027 18.3174 8.66823C18.1294 9.91619 16.9245 10.9347 15.6347 10.9347ZM25.4104 4.33186H23.4477C23.0415 4.33186 22.8763 4.62585 23.0052 5.00084L25.4514 12.0896L23.0415 15.4615C22.84 15.7435 22.9961 16 23.2795 16H25.4938C25.8242 16 25.9849 15.916 26.1516 15.6805L33.6751 5.00084C33.907 4.67235 33.7979 4.32736 33.4174 4.32736H31.3244C30.9652 4.32436 30.8212 4.46536 30.6151 4.76235L27.4777 9.26821L26.0819 4.75485C25.9955 4.47736 25.7909 4.33336 25.4135 4.33336L25.4104 4.33186Z"
              fill="#113984"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M41.5029 0.00299997C43.4838 0.00299997 45.3116 1.06647 45.0615 3.71688C44.7645 6.85928 43.0534 8.60973 40.3616 8.61723H38.0139C37.676 8.61723 37.5123 8.89022 37.4244 9.4497L36.9712 12.3101C36.903 12.7421 36.6787 12.9551 36.3483 12.9551H34.1612C33.8127 12.9551 33.6914 12.7346 33.7687 12.2411L35.5768 0.773976C35.6662 0.209993 35.883 0 36.2695 0H41.5044L41.5029 0.00299997ZM37.9412 6.14081H39.722C40.836 6.09881 41.5756 5.33683 41.6499 3.95838C41.6954 3.1079 41.1149 2.49892 40.1919 2.50342L38.5156 2.51092L37.9412 6.14081ZM51.0073 12.0776C51.2074 11.8976 51.4105 11.8046 51.3817 12.0266L51.3104 12.5576C51.2741 12.8351 51.3847 12.9821 51.6454 12.9821H53.5884C53.9158 12.9821 54.0749 12.8516 54.1552 12.3506L55.3526 4.91385C55.4132 4.54036 55.3208 4.35736 55.0343 4.35736H52.8988C52.7063 4.35736 52.6123 4.46386 52.5623 4.75485L52.4835 5.21234C52.4426 5.45083 52.332 5.49283 52.2289 5.25283C51.8667 4.40386 50.9421 4.02287 49.6448 4.04837C46.6484 4.10987 44.6281 6.3613 44.4114 9.24721C44.2446 11.4791 45.8603 13.2326 47.9912 13.2326C49.5372 13.2326 50.2283 12.7766 51.0073 12.0776ZM49.3811 10.9347C48.0913 10.9347 47.1925 9.91619 47.3789 8.66823C47.5669 7.42027 48.7718 6.4018 50.0616 6.4018C51.3514 6.4018 52.2501 7.42027 52.0637 8.66823C51.8758 9.91619 50.6708 10.9347 49.3811 10.9347ZM58.3429 12.9956H56.0998C55.9209 12.9956 55.7982 12.8576 55.8255 12.6881L57.7973 0.334489C57.8246 0.164995 57.9928 0.0269992 58.1701 0.0269992H60.4132C60.5921 0.0269992 60.7148 0.164995 60.6876 0.334489L58.7157 12.6881C58.6885 12.8576 58.5217 12.9956 58.3429 12.9956Z"
              fill="#009EE3"
            />
          </svg>
          <span>Buy now</span>
        </button>
      </a-spin>
      <p class="purchase__payment__paypal--text">
        The safer, easier way to pay
      </p>
    </div>

    <hr class="payments__divider" />

    <div class="payments__total">
      <p>Total</p>
      <p>{{ currency }}{{ totalAmount }}</p>
    </div>

    <p class="payments__info" v-if="annualPackage">
      You may cancel at any time in your trial. {{ currency
      }}{{ annualPackage.amount }}
      billed annually after trial. To cancel your subscription, email us at
      help@mentalfuture.com
    </p>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { message, notification } from 'ant-design-vue'
import { createSubscription, getSetupIntent } from '@/services/stripe.service'
import { getPaypal } from '@/services/braintree.service'
import {
  purchaseTypes,
  currency,
  checkoutTypes,
  packagePlaces,
} from '@/data/constants'
import { getCountryByIp } from '@/services/other.service'
import { getCurrency } from '@/utils/helpers'
import { loadFacebookPixel } from '@/utils/facebookConfig'

const cardNumberOption = {
  style: {
    base: {
      iconColor: '#fff',
      color: '#fff',
      fontFamily: "'Manrope Medium', sans-serif",
      fontSize: '14px',
      '::placeholder': {
        color: 'rgba(255,255,255,0.4)',
      },
      textAlign: 'center',
    },
    invalid: {
      iconColor: '#fff',
      color: 'red',
    },
  },
  classes: {
    base: 'purchase__input',
  },
}

export default {
  name: 'Payments',
  emits: ['onSuccess'],
  props: {
    package: {
      type: String,
      default: '',
    },
    isEurope: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stripe: null,
      elements: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      isLoading: false,
      setupIntent: {},
      isCardLoading: false,
      isPaypal: true,
      paypalUrl: null,
      isPaypalLoading: false,
      errorMessage: '',
      annualPackage: {},
      userIpInfo: {},
    }
  },
  computed: {
    ...mapState('packageModule', ['packages']),
    ...mapState('subscription', ['action']),
    ...mapState('checkout', ['checkoutType']),
    provider() {
      return this.isPaypal ? 'paypal' : 'stripe'
    },
    currentPackage() {
      let p = {}
      switch (this.package) {
        case purchaseTypes.MONTHLY:
          p = this.packages.find(
            (i) =>
              i.months === 1 &&
              this.provider === i.provider &&
              (this.isEurope
                ? i.currency === currency.EUR
                : i.currency === currency.USD)
          )
          if (!p) {
            p = this.packages.find(
              (i) =>
                i.months === 1 &&
                this.provider === i.provider &&
                i.currency === currency.USD
            )
          }
          this.errorMessage = 'There is no package for a month'
          break
        case purchaseTypes.YEARLY:
          p = this.packages.find(
            (i) =>
              i.months === 12 &&
              this.provider === i.provider &&
              (this.isEurope
                ? i.currency === currency.EUR
                : i.currency === currency.USD)
          )
          if (!p) {
            p = this.packages.find(
              (i) =>
                i.months === 12 &&
                this.provider === i.provider &&
                i.currency === currency.USD
            )
          }
          this.errorMessage = 'There is no package for a year'
          break
        case purchaseTypes.LIFETIME:
          p = this.packages.find((i) => {
            i.is_lifetime &&
              this.provider === i.provider &&
              (this.isEurope
                ? i.currency === currency.EUR
                : i.currency === currency.USD)
          })
          if (!p) {
            p = this.packages.find(
              (i) =>
                i.is_lifetime &&
                this.provider === i.provider &&
                i.currency === currency.USD
            )
          }
          this.errorMessage = 'There is no lifetime package'
          break
      }

      return p || {}
    },
    currency() {
      return this.getCurrency(this.currentPackage.currency)
    },
    isLifetime() {
      return this.package === purchaseTypes.LIFETIME
    },
    totalAmount() {
      return purchaseTypes.YEARLY === this.package
        ? '0.00'
        : this.currentPackage.amount
    },
  },
  created() {
    getCountryByIp()
      .then((res) => {
        this.userIpInfo = res
        this.fetchPackages()
      })
      .catch((err) => {
        this.fetchPackages()
        console.log(err)
      })
  },
  async mounted() {
    if (this.isPaypal) {
      this.onSwitchPaypal()
    }
    this.loadFacebookPixel()
    fbq('track', 'InitiateCheckout')
    this.getAnnualPackage()
    this.isCardLoading = true
    this.setupIntent = await getSetupIntent()
    this.stripe = Stripe(this.setupIntent.api_key)
    this.elements = this.stripe.elements()
    this.cardNumber = this.elements.create('cardNumber', cardNumberOption)
    this.cardNumber.mount('#purchase-number')
    this.cardExpiry = this.elements.create('cardExpiry', cardNumberOption)
    this.cardExpiry.mount('#purchase-card-expiry')
    this.cardCvc = this.elements.create('cardCvc', cardNumberOption)
    this.cardCvc.mount('#purchase-card-cvc')
    this.isCardLoading = false
  },
  beforeDestroy() {
    this.cardNumber.destroy()
    this.cardExpiry.destroy()
    this.cardCvc.destroy()
  },
  methods: {
    ...mapActions('packageModule', ['getPackageByType']),
    ...mapActions('packageModule', ['fetchPackage']),
    loadFacebookPixel,
    getCurrency,
    async getAnnualPackage() {
      this.annualPackage = await this.getPackageByType({
        type: purchaseTypes.YEARLY,
        provider: this.isPaypal ? 'paypal' : 'stripe',
        currency: this.isEurope ? currency.EUR : currency.USD,
      })
    },
    fetchPackages() {
      if (!this.checkoutType) {
        this.fetchPackage({
          place: packagePlaces.AFTER_LOCKED_CONTENT,
          currency: this.isEurope ? currency.EUR : currency.USD,
        })
      }
    },
    async onConfirm() {
      if (!this.currentPackage) {
        notification.error({
          message: this.errorMessage,
        })
        return
      }
      this.isLoading = true
      this.stripe
        .confirmCardSetup(this.setupIntent.client_secret, {
          payment_method: {
            card: this.cardNumber,
          },
        })
        .then((res) => {
          if (res.error) {
            notification.error({
              message: res.error.message || 'Something went wrong',
            })
            this.isLoading = false
          } else {
            this.savePaymentMethod(res.setupIntent.payment_method)
          }
        })
        .catch((err) => {
          this.isLoading = false
        })
    },

    async onSwitchPaypal() {
      this.isPaypalLoading = true
      this.isPaypal = true
      if (Object.keys(this.currentPackage).length === 0) {
        notification.error({
          message: this.errorMessage,
        })
        return
      }
      try {
        const payload = {
          package_id: this.currentPackage.id,
          timezone: this.userIpInfo.timezone,
        }
        const checkoutId = this.$route.params.checkoutId

        if (checkoutId) {
          if (this.checkoutType === checkoutTypes.PROMO)
            payload.promo_checkout_id = checkoutId
          else payload.checkout_id = checkoutId
        }

        const data = await getPaypal(payload)
        this.paypalUrl = data.url_to_redirect
        this.isPaypalLoading = false
      } catch (err) {
        this.isPaypalLoading = false
      }
    },

    onClickPaypal() {
      if (this.paypalUrl) window.location.assign(this.paypalUrl)
    },

    onSendStripe() {
      this.savePaymentMethod()
    },

    savePaymentMethod(payment_method) {
      const data = {
        payment_method,
        package_id: this.currentPackage.id,
      }

      if (this.checkoutType === checkoutTypes.CHECKOUT) {
        data.checkout_id = this.$route.params.checkoutId
      } else if (this.checkoutType === checkoutTypes.PROMO) {
        data.promo_checkout_id = this.$route.params.checkoutId
      }
      createSubscription(data)
        .then((res) => {
          if (this.currentPackage.is_free_trial) {
            fbq('track', 'StartTrial')
          } else {
            fbq('track', 'Purchase', {
              currency: this.currentPackage.currency,
              value: this.currentPackage.amount,
            })
          }
          notification.success({ message: 'Successfully subscribed!' })
          if (res.redirect_url) {
            const redirect_url =
              res.redirect_url +
              (res.message === 'need approve'
                ? `?redirect=${window.location.href}`
                : '')
            window.location.assign(redirect_url)
          } else {
            this.$emit('onSuccess')
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
.payments {
  &__wrapper {
    max-width: 327px;
    margin: 0 auto;
    padding: 72px 0;
    position: relative;
  }

  .purchase__card {
    background: rgba(#fff, 0.1);
    border-radius: 12px;
  }

  &__divider {
    border-color: rgba(#fff, 0.1);
    margin: 0;
  }

  &__total {
    display: flex;
    justify-content: space-between;
    margin: 16px 0 24px;

    & > p {
      font-weight: 700;
      font-size: 20px;
      line-height: 27px;
      color: var(--color-white);
    }
  }

  &__info {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--color-white);
  }
}
.lifetime {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
</style>
